"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbToastrContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _sbToastr = require("./sb-toastr");

var _actions = require("./actions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line
var mapStateToProps = function mapStateToProps(state) {
  return {
    toasts: state.get ? state.get('toasts') : state.toasts
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    removeToast: function removeToast(id) {
      return dispatch((0, _actions.removeToast)(id));
    }
  };
};
/** In order to use this container, toastrReducer must be added to the reducers as toasts: toastrReducer. */


var SbToastrContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_sbToastr.SbToastr);
exports.SbToastrContainer = SbToastrContainer;
//# sourceMappingURL=sb-toastr-container.js.map